export const json = {
  completedHtml: 'Благодарим за сотрудничество!',
  pages: [
    {
      elements: [
        {
          choices: [
            {
              value: 'yes',
              text: 'да',
            },
            {
              value: 'no',
              text: 'нет',
            },
          ],
          name: '1_element',
          showNumber: true,
          title:
            'Считаете ли Вы модель финала Всероссийского конкурса 2020 года в целом достаточной для объективного выявления лауреатов и победителя конкурса?',
          type: 'radiogroup',
        },
        {
          name: '2_element',
          showNumber: true,
          title:
            'Назовите конкурсное испытание (испытания), которое, по Вашему мнению, следует включить в первый тур финала Конкурса:',
          type: 'comment',
        },
        {
          choices: [
            'высокая степень достаточности, корректности и понятности',
            'средняя степень достаточности, корректности и понятности',
            'низкая степень достаточности, корректности и понятности',
          ],
          name: '3_element',
          showNumber: true,
          hasOther: true,
          title:
            'В какой степени, по Вашему мнению, достаточно, корректно и понятно сформулированы критерии конкурсного испытания «Методическая мастерская»?',
          type: 'checkbox',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '4_1',
              title: ' ',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '4_2',
              title: 'Предложите оптимальную, на Ваш взгляд, продолжительность:',
              type: 'text',
            },
          ],
          name: '4_element',
          showNumber: true,
          title:
            'Считаете ли Вы достаточной и оптимальной продолжительность (15 минут) представления конкурсантом практики обучения и воспитания обучающихся в конкурсном испытании «Методическая мастерская»?',
          type: 'panel',
        },
        {
          name: '5_element',
          title:
            'Перечислите затруднения, которые Вы испытали при проведении конкурсного испытания «Методическая мастерская»:',
          type: 'comment',
        },
        {
          choices: [
            'высокая степень достаточности, корректности и понятности',
            'средняя степень достаточности, корректности и понятности',
            'низкая степень достаточности, корректности и понятности',
          ],
          name: '6_element',
          hasOther: true,
          title:
            'В какой степени, по Вашему мнению, достаточно, корректно и понятно сформулированы критерии конкурсного испытания «Урок»? ',
          type: 'checkbox',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '7_1',
              title: ' ',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '7_2',
              title: 'Предложите оптимальную, на Ваш взгляд, продолжительность:',
              type: 'text',
            },
          ],
          name: '7_element',
          showNumber: true,
          title:
            'Считаете ли Вы достаточной и оптимальной продолжительность (35 минут) общения конкурсанта с обучающимися в конкурсном испытании «Урок»?',
          type: 'panel',
        },
        {
          name: '8_element',
          title:
            'Перечислите затруднения, которые Вы испытали при проведении конкурсного испытания «Урок»:',
          type: 'comment',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '9_1',
              title: 'достаточна:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '9_2',
              title:
                'объективна:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '9_3',
              title: 'отражает современные подходы к оцениванию деятельности учителя:',
              type: 'radiogroup',
            },
          ],
          name: '9_element',
          showNumber: true,
          title:
            'Насколько, по Вашему мнению, система критериев и показателей оценивания конкурсных испытаний первого тура Конкурса-2020: ',
          type: 'panel',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '10_1',
              title: 'достаточна:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '10_2',
              title:
                'объективна:',
              type: 'radiogroup',
            },
          ],
          name: '10_element',
          showNumber: true,
          title:
            'Насколько, по Вашему мнению, используемая шкала оценивания конкурсных испытаний (0-1-2 балла)',
          type: 'panel',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '11_1',
              title: 'оптимально и целесообразно:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '11_2',
              title:
                'соответствует специфике деятельности учителя:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '11_3',
              title:
                'позволяет объективнее оценить выступление конкурсанта:',
              type: 'radiogroup',
            },
          ],
          name: '11_element',
          showNumber: true,
          title:
            'Считаете ли Вы, что оценивание конкурсных испытаний первого тура Конкурса группами жюри, сформированного на межпредметной основе,',
          type: 'panel',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '12_1',
              title: ' ',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '12_2',
              title: 'Прокомментируйте свой ответ:',
              type: 'text',
            },
          ],
          name: '12_element',
          showNumber: true,
          title:
            'Как Вы полагаете, Всероссийский конкурс «Учитель года России» способствует популяризации педагогической профессии и повышению престижа профессии учителя?',
          type: 'panel',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '13_1',
              title: ' ',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '13_2',
              title: 'Прокомментируйте свой ответ:',
              type: 'text',
            },
          ],
          name: '13_element',
          showNumber: true,
          title:
            'Как Вы считаете, Всероссийский конкурс «Учитель года России» способствует профессиональному совершенствованию работников общего образования?',
          type: 'panel',
        },
        {
          name: '14_element',
          title: 'Какой опыт Вы приобрели в процессе участия в первом туре Всероссийского конкурса «Учитель года России» 2020 года?',
          type: 'comment',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '15_1',
              title: ' ',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '15_2',
              title: 'Прокомментируйте свой ответ:',
              type: 'text',
            },
          ],
          name: '15_element',
          showNumber: true,
          title:
            ' Намерены ли Вы далее участвовать в конкурсном движении?',
          type: 'panel',
        },
        {
          name: '16_element',
          title: 'Выскажите свои пожелания по совершенствованию организации и проведения финала Конкурса:',
          type: 'comment',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'no',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '17_1',
              title: 'организация конкурсных испытаний:',
              type: 'checkbox',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'no',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '17_2',
              title: 'мероприятия по программе:',
              type: 'checkbox',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'no',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '17_3',
              title: 'информационное сопровождение:',
              type: 'checkbox',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'no',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '17_4',
              title: 'трансфер:',
              type: 'checkbox',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'no',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '17_5',
              title: 'проживание:',
              type: 'checkbox',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'no',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '17_6',
              title: 'питание:',
              type: 'checkbox',
            },
          ],
          name: '17_element',
          showNumber: true,
          title:
            'Оцените уровень организации Вашего пребывания на заключительном этапе Конкурса-2020:',
          type: 'panel',
        },
      ],
      name: 'page1',
      showNumber: false,
      showQuestionNumbers: 'true',
      title:
        'Уважаемый участник Конкурса! Просим Вас выразить свое мнение об организации и проведении Всероссийского конкурса «Учитель года России» 2020 года. Ваши ответы помогут при подготовке и проведении Всероссийского конкурса «Учитель года России» в 2021 году.',
    },
  ],
  showCompletedPage: true,
  title: 'АНКЕТА УЧАСТНИКА ПЕРВОГО ТУРА финала Всероссийского конкурса «Учитель года России» 2020 года'
};
